class CoreTextTruncate extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('.core-text__body');
    this.toggle = this.querySelector('.core-text__toggle');
    if (!this.body || !this.toggle) return;

    this.toggle.addEventListener('click', this.#onToggle);
    this.#update();

    this._resizeObserver = new ResizeObserver(() => this.#update());
    this._resizeObserver.observe(this.body);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.#onToggle);
    this._resizeObserver?.disconnect();
  }

  #onToggle = () => {
    const willExpand = !this.classList.contains('is-expanded');
    const coreText = this.closest('.core-text');
    const collapsedHeight = willExpand ? (coreText?.offsetHeight ?? this.body.offsetHeight) : 0;

    const expanded = this.classList.toggle('is-expanded');
    this.toggle.setAttribute('aria-expanded', String(expanded));

    this.dispatchEvent(
      new CustomEvent('core-text:toggle', {
        bubbles: true,
        detail: { expanded, collapsedHeight },
      })
    );

    if (!expanded) {
      requestAnimationFrame(() => this.#update());
    }
  };

  #update() {
    if (this.classList.contains('is-expanded')) return;

    const overflowing = this.body.scrollHeight > this.body.clientHeight + 1;
    this.toggle.hidden = !overflowing;
  }
}

customElements.define('core-text-truncate', CoreTextTruncate);
